module.exports = __webpack_public_path__ + "img/logo_color.bcf2b4b7.png";